import { useEffect, useState } from "react";
import { renderTerrain, renderVectorLayer3D, TileMapLayer } from "../singleLayer/renderLayerService";
import DeckGL, { MapController } from "deck.gl";
import 'mapbox-gl/dist/mapbox-gl.css';

export function SingleLayerDeckGLH3({
    data,
    viewState,
    setViewState,
    isView3d,
    mapTheme,
    colorMapName,
    colorMapOpacity,
    color,
    height,
    zoom,
    domain
}) {
    const [layer, setLayer] = useState([]);

    function getTooltip({ object }) {
        if (object && object.properties) {
            return {
                html: `\
                <div style="display: table;">
                <h2>Exposure</h2>
                ${color !== 'avg_building_height' && height !== 'avg_building_height' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Average Building Height:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.avg_building_height?.toFixed(2)} m</div>
                    </div>
                ${color !== 'building_area' && height !== 'building_area' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Building Area:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.building_area)} m<sup>2</sup></div>
                    </div>
                ${color !== 'population' && height !== 'population' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Population:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.population)}</div>
                    </div>
                ${color !== 'num_res_buildings' && height !== 'num_res_buildings' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Number of Residential Buildings:</div>
                        <div style="display: table-cell; padding: 5px"> ${Math.round(object.properties.num_res_buildings)}</div>
                    </div>
                ${color !== 'num_buildings' && height !== 'num_buildings' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Total Number of Buildings:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.num_buildings)}</div>
                    </div>
                </div>
                <h2>Hazard</h2>
                ${color !== 'earthquake' && height !== 'earthquake' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Earthquake Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.earthquake?.toFixed(2)}</div>
                    </div>
                ${color !== 'flash-flood' && height !== 'flash-flood' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Flash Flood Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties['flash-flood']?.toFixed(2)}</div>
                    </div>
                ${color !== 'flood' && height !== 'flood' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Flood Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.flood?.toFixed(2)}</div>
                    </div>
                ${color !== 'landslide' && height !== 'landslide' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Landslide Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.landslide?.toFixed(2)}</div>
                    </div>
                ${color !== 'tsunami' && height !== 'tsunami' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Tsunami Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.tsunami?.toFixed(2)}</div>
                    </div>
                ${color !== 'volcanic' && height !== 'volcanic' ? `<div style="display: table-row;">` : `<div style="display: table-row; background-color: #40507a;">`}
                        <div style="display: table-cell; padding: 5px">Volcanic Hazard:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.volcanic?.toFixed(2)}</div>
                    </div>  
      `,
                style: {
                    backgroundColor: '#000b27',
                    borderRadius: '20px',
                    border: '4px #ffffff9c solid',
                    boxShadow: '6px 0 16px 0 rgba(0, 0, 0, 0.08), 3px 0 6px -4px rgba(0, 0, 0, 0.12), 9px 0 28px 8px rgba(0, 0, 0, 0.05)'
                }
            }
        }

    }

    function getLayers(isView3d, data, colorMapName, mapTheme, colorMapOpacity, domain) {

        return [
            renderTerrain(isView3d),
            TileMapLayer(mapTheme),
            renderVectorLayer3D({ data: data, colorMapName: colorMapName, color: color, height: height, colorMapOpacity: colorMapOpacity, zoom: zoom, domain: domain }),
        ]
    }

    useEffect(() => {
        data && setLayer(getLayers(isView3d, data, colorMapName, mapTheme, colorMapOpacity, domain))
    }, [data, isView3d, colorMapName, mapTheme, colorMapOpacity, color, height, zoom]);

    useEffect(() => {

        setViewState({
            ...viewState,
            pitch: isView3d ? 60 : 0,
            transitionDuration: 400,
        })

    }, [isView3d]);

    return (
        <DeckGL
            controller={{ type: MapController }}
            initialViewState={viewState}
            getTooltip={getTooltip}
            onViewStateChange={({ viewState }) => setViewState(viewState)}
            layers={layer}>
        </DeckGL>

    )
}